/* eslint-disable react/display-name */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { forwardRef, memo } from 'react';
import './styles.scss';
import TButton, { ButtonAnalytics } from './Button';
import { ButtonProps } from './types';

/**
 * UI Toolkit button component
 * @public
 */
const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    children,
    trackId,
    canReturnParams,
    stopTracking,
    trackCategory,
    trackedHandlers,
    untrackedHandlers,
    ...rest
  } = props;
  if (trackId) {
    return (
      <ButtonAnalytics
        {...rest}
        trackId={trackId}
        canReturnParams={canReturnParams}
        stopTracking={stopTracking}
        trackCategory={trackCategory}
        trackedHandlers={trackedHandlers}
        untrackedHandlers={untrackedHandlers}
        ref={ref}
      >
        {children}
      </ButtonAnalytics>
    );
  }
  return (
    <TButton
      {...rest}
      ref={ref}
    >
      {children}
    </TButton>
  );
});

export default memo(Button);
